
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import NotFoundView from "@/components/NotFoundView";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <NotFoundView 
      title="404"
      message="Oops! Page not found"
      linkText="Return to Home"
      linkTo="/"
    />
  );
};

export default NotFound;
